import React, { useState } from "react";

const testimonios = [
  {
    texto:
      "Aprendí que no estamos jugando a ser cristianos, la visión misionera es algo serio, y Dios no es un juego. El Señor cambió mi vida porque tenía la mentalidad de escapar de su llamado, de escapar del servicio y tomarlo todo sin importancia. ¡Dios cambió eso en este campamento y me llamó! Ahora yo tengo una visión misionera y mi vida, mi tiempo y mi juventud le pertenecen a Cristo, les recomiendo ser parte de esta experiencia.",
    autor: "Eminen . O",
  },
  {
    texto:
      "He aprendido en este campamento a tener disciplina, a ser servicial, a hablar a los demás con seguridad del amor de Cristo, un amor para todos nosotros y que yo debo ser una fuente de amor y esperanza para los demás. Y tú también puedes ser parte de esto.",
    autor: "Francis . DA",
  },
  {
    texto:
      "He aprendido que Dios tiene un propósito para mi vida, que Dios me ha llamado a poder servirle en todo lo que Él tenga designado para hacer. He aprendido lo valioso que es poder entregar nuestra juventud a Él. Participa de este campamento.",
    autor: "Josue . A",
  },
];

export default function Testimonios() {
  const [indiceActual, setIndiceActual] = useState(0);

  // TESTIMONIO ANTERIOR
  const testimonioAnterior = () => {
    setIndiceActual((indice) =>
      indice === 0 ? testimonios.length - 1 : indice - 1,
    );
  };

  // TESTIMONIO SIGUIENTE
  const testimonioSiguiente = () => {
    setIndiceActual((indice) =>
      indice === testimonios.length - 1 ? 0 : indice + 1,
    );
  };

  return (
    <section className="testimonios-section">
      {/* CONTENEDOR PRINCIPAL */}
      <div className="testimonios-contenedor">
        {/* FLECHA IZQUIERDA */}
        <button
          type="button"
          className="testimonio-flecha testimonio-flecha-izquierda"
          onClick={testimonioAnterior}
          aria-label="Testimonio anterior"
        >
          ‹
        </button>
        {/* TESTIMONIO */}
        <div className="testimonio-contenido">
          <p className="testimonio-texto">{testimonios[indiceActual].texto}-<strong>{testimonios[indiceActual].autor}</strong></p>

        </div>

        {/* FLECHA DERECHA */}

        <button
          type="button"
          className="testimonio-flecha testimonio-flecha-derecha"
          onClick={testimonioSiguiente}
          aria-label="Siguiente testimonio"
        >
          ›
        </button>
      </div>

      {/* INDICADORES */}

      <div className="testimonios-indicadores">
        {testimonios.map((_, index) => (
          <button
            key={index}
            type="button"
            className={
              index === indiceActual ? "indicador activo" : "indicador"
            }
            onClick={() => setIndiceActual(index)}
            aria-label={`Mostrar testimonio ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
